/**
 * @license
 * Copyright Paysafe 2026. All rights reserved.
 */

import { CheckoutErrorType } from '../enums/checkout-error-type.enum';

const XMARK_ERROR_ILLUSTRATION = 'x-mark-red.svg';

export const DEFAULT_ERROR_ILLUSTRATION = XMARK_ERROR_ILLUSTRATION;

/**
 * Maps error types to illustration file names
 * All text content is now in i18n files (src/assets/i18n/)
 */
export const ERROR_ILLUSTRATION_MAP: Record<CheckoutErrorType, string> = {
  [CheckoutErrorType.INSUFFICIENT_FUNDS]: XMARK_ERROR_ILLUSTRATION,
  [CheckoutErrorType.PAYMENT_IN_PROGRESS]: XMARK_ERROR_ILLUSTRATION,
  [CheckoutErrorType.WALLET_RESTRICTED]: XMARK_ERROR_ILLUSTRATION,
  [CheckoutErrorType.PAYMENT_TIMED_OUT]: XMARK_ERROR_ILLUSTRATION,
  [CheckoutErrorType.TRANSACTION_FAILED]: XMARK_ERROR_ILLUSTRATION,
  [CheckoutErrorType.PAYMENT_CANCELLED]: XMARK_ERROR_ILLUSTRATION,
  [CheckoutErrorType.LIMITS_EXCEEDED]: XMARK_ERROR_ILLUSTRATION,
  [CheckoutErrorType.SCA_CODE_NOT_SENT]: XMARK_ERROR_ILLUSTRATION,
  [CheckoutErrorType.SCA_TOO_MANY_REQUESTS]: XMARK_ERROR_ILLUSTRATION,
  [CheckoutErrorType.SCA_INCORRECT_CODE]: XMARK_ERROR_ILLUSTRATION,
  [CheckoutErrorType.GENERAL]: XMARK_ERROR_ILLUSTRATION,
  [CheckoutErrorType.CUSTOM]: XMARK_ERROR_ILLUSTRATION
};
